import { render, staticRenderFns } from "./_OngoingFlowCard.vue?vue&type=template&id=b9f982ec&scoped=true"
import script from "./_OngoingFlowCard.vue?vue&type=script&lang=js"
export * from "./_OngoingFlowCard.vue?vue&type=script&lang=js"
import style0 from "./_OngoingFlowCard.vue?vue&type=style&index=0&id=b9f982ec&prod&lang=sass"
import style1 from "./_OngoingFlowCard.vue?vue&type=style&index=1&id=b9f982ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f982ec",
  null
  
)

export default component.exports